import { TOfferCategory } from '@cian/chats-api';

import { mapMessage } from './mapMessage';
import { IOffer } from '../repositories/chats/entities/offer/Offer';
import { ISyncChat } from '../repositories/chats/entities/synchronization/SyncChat';
import { IChat } from '../types/chatList';
import { TOffer } from '../types/offer';

export const mapChat = (chat: ISyncChat): IChat => {
  const { datetimeForSorting, ...chatProps } = chat;

  const updated = new Date(datetimeForSorting).getTime();

  return {
    ...chatProps,
    updated,
    offer: chat.offer ? mapOffer(chat.offer) : undefined,
    lastMessage: chat.lastMessage ? mapMessage(chat.lastMessage) : undefined,
  };
};

function mapOffer(offer: IOffer): TOffer {
  return {
    ...offer,
    category: (offer.category || 'flatSale') as TOfferCategory,
    fullUrl: offer.fullUrl || '',
  };
}
